import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from '@thd-olt-component-react/router';
import {
  Button, Col, Row, Overlay, Image
} from '@thd-olt-component-react/core-ui';
import { overlayEvents } from '../../utils/analytics';
import ModalHeader from '../../components/common/ModalHeader/ModalHeader';
import { generateImageSource } from '../../utils/generateImageSource';

const TutorialOverlay = ({ onClose, isOpen }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      overlayEvents.welcomeMessage();
    }
  }, [isOpen]);

  return (
    <Overlay
      modalClass="p2p-overlay tutorial"
      onClose={onClose}
      open={isOpen}
      closeButton
      positionedCloseButton
    >
      <>
        <ModalHeader style={{ color: '#F96302' }}>Welcome to the Path To Pro Network!</ModalHeader>
        <section className="landing-tutorial__wrapper">
          <section className="landing-tutorial__instruction-section">
            <img
              className="landing-tutorial__constructors-image"
              alt="find-candidate"
              src={generateImageSource('/images/v1/path-to-pro/construction-group-splash.png')}
            />
            <section className="landing-tutorial__instruction-section-text">
              How to find skilled labor in your area:
              <ol className="landing-tutorial__instruction-section-list">
                <li>Go to the “Find Candidates” tab</li>
                <li>Using the filters, filter to your preferred qualifications</li>
                <li>
                  View a candidate’s profile for their work experience, qualifications, and credentials
                </li>
                <li>Click “Call Me” or “Email Me” to contact them or invite them to apply to your open job postings</li>
              </ol>
            </section>
          </section>
          <hr className="landing-tutorial__page-break" />

          {/* Desktop Pictures */}
          <Image
            className="landing-tutorial__image landing-tutorial__desktop"
            src={generateImageSource('/images/v1/path-to-pro/graphic-1-SHIW-DT&Tablet@2X_2.png')}
          />
          <Image
            className="landing-tutorial__image landing-tutorial__desktop"
            src={generateImageSource('/images/v1/path-to-pro/graphic-2-SHIW-DT&Tablet@2X_3.png')}
          />
          <Image
            className="landing-tutorial__image landing-tutorial__desktop"
            src={generateImageSource('/images/v1/path-to-pro/graphic-3-SHIW-DT&Tablet@2X.png')}
          />

          {/* Mobile Pictures */}
          <Image
            className="landing-tutorial__image landing-tutorial__mobile"
            src={generateImageSource('/images/v1/path-to-pro/graphic-1-SHIW-MW@2X_2.png')}
          />
          <Image
            className="landing-tutorial__image landing-tutorial__mobile"
            src={generateImageSource('/images/v1/path-to-pro/graphic-2-SHIW-MW@2X_3.png')}
          />
          <Image
            className="landing-tutorial__image landing-tutorial__mobile"
            src={generateImageSource('/images/v1/path-to-pro/graphic-3-SHIW-MW@2X_2.png')}
          />
          <Image
            className="landing-tutorial__image landing-tutorial__mobile"
            src={generateImageSource('/images/v1/path-to-pro/graphic-4-SHIW-MW@2X_2.png')}
          />
        </section>
        <hr className="landing-tutorial__page-break" />
        <Row className="landing-tutorial__btn-row">
          <Col xs={8} />
          <Col xs={4}>
            <Button
              data-testid="find-candidates-tutorial-btn"
              onClick={() => {
                navigate('/path-to-pro-network/search');
              }}
            >
              Find Candidates
            </Button>
          </Col>
        </Row>
      </>
    </Overlay>
  );
};
TutorialOverlay.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default TutorialOverlay;
